import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom, Subscription } from 'rxjs';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { IProject } from '../projects.interface';
import { ProjectsService } from '../projects.service';
import { ProjectsHttpService } from '../projects-http.service';
import { ProjectsModalComponent } from '../projects-modal/projects-modal.component';
import { IFilter } from '../../../../shared/interfaces/filter.interface';
import { ITask, ITaskFilter } from '../../../tasks-page/tasks/task.interface';
import { ITaskCommentFilter } from '../../../tasks-page/tasks/task-comment/task-comment.interface';
import { IBillingDocument, IBillingDocumentFilter, IBillingDocumentNames } from '../../../billing-documents-page/billing-documents/billing-documents.interface';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { FileViewModalComponent } from '../../../../shared/components/file-view-modal/file-view-modal.component';
import { IFile } from '../../../../shared/components/files/file.interface';
import { AuthService } from '../../../../shared/services/auth.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { BillingDocumentsModalComponent } from '../../../billing-documents-page/billing-documents/billing-documents-modal/billing-documents-modal.component';
import { InvoiceStatusesLabels, InvoiceStatusesColors, InvoiceStatuses } from '../../../billing-documents-page/billing-documents/billing-documents.constants';
import { ClientsModalComponent } from '../../../clients-page/clients/clients-modal/clients-modal.component';
import { IClient } from '../../../clients-page/clients/clients.interface';
import { DeliveryNotesPDFModalComponent } from '../../../delivery-notes-page/delivery-notes/delivery-notes-pdf-modal/delivery-notes-pdf-modal.component';
import { getEmptyDetailItemExpense } from '../../../expenses-page/expenses/expenses.interface';
import { QuotesModalComponent } from '../../../quotes-page/quotes/quotes-modal/quotes-modal.component';
import { QuoteStatusesLabels } from '../../../quotes-page/quotes/quotes.constants';
import { SETTINGS } from '../../../settings-page/settings/settings.constants';
import { SettingsService } from '../../../settings-page/settings/settings.service';
import { TaskModalComponent } from '../../../tasks-page/tasks/task-modal/task-modal.component';
import { TaskSingleComponent } from '../../../tasks-page/tasks/task-single/task-single.component';
import { TaskStatuses } from '../../../tasks-page/tasks/task.constants';
import { WorkersModalComponent } from '../../../workers-page/workers/workers-modal/workers-modal.component';
import { IWorker } from '../../../workers-page/workers/workers.interface';
let self: any;

@Component({
  selector: 'app-projects-detail',
  templateUrl: './projects-detail.component.html',
  styleUrls: ['./projects-detail.component.css']
})
export class ProjectsDetailComponent implements OnInit {

  /* refactor */
  openPdf(file: any) {
    throw new Error('Method not implemented.');
  }

  project!: IProject;
  tasks: any[] = [];
  quotes: any[] = [];
  invoices: any[] = [];
  deliveryNotes: any[] = [];
  attachments: any[] = [];
  loading: boolean = true;
  thereAreMore: boolean = false;
  filter: IFilter = {
    // filters: {
    //   isDeleted: false
    // },
    sort: '',
    skip: 0,
    limit: 20
  };

  //Task
  filterTask!: ITaskFilter;
  loadingTask: boolean = true;
  thereAreMoreTask: boolean = false;

  //Quotes
  filterQuotes!: IFilter;
  loadingQuotes: boolean = true;
  thereAreMoreQuotes: boolean = false;

  //Invoices
  filterInvoices!: IBillingDocumentFilter;
  loadingInvoices: boolean = true;
  thereAreMoreInvoices: boolean = false;

  //Delivery Notes
  filterDeliveryNotes!: IFilter;
  loadingDeliveryNotes: boolean = true;
  thereAreMoreDeliveryNotes: boolean = false;

  //Attachments
  filterAttachments!: ITaskCommentFilter;
  loadingAttachments: boolean = true;
  thereAreMoreAttachments: boolean = false;

  filtered = false;
  totalMoreMinTutorial = false;
  changesSubscription!: Subscription;
  querySubscription!: Subscription;
  selection: any = { all: false };
  isDev!: boolean;
  dialog: MatDialogRef<any>;
  dateFormated!: string;

  //status
  taskStatusColors: any = {};
  taskStatuses: any = TaskStatuses;
  quoteStatuses: any = QuoteStatusesLabels;
  quoteStatusesKeys = Object.keys(QuoteStatusesLabels);
  quoteStatusColors: any = {};
  invoiceStatusesLabels: any = InvoiceStatusesLabels;
  invoiceStatusesColors: any = InvoiceStatusesColors;
  invoiceStatuses: any = InvoiceStatuses;
  invoiceStatusesKeys = Object.keys(InvoiceStatuses);

  constructor(
    private _ProjectsHttpService: ProjectsHttpService,
    private _ProjectsService: ProjectsService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    private _UtilService: UtilsService,
    private _SettingsService: SettingsService,
  ) {
    self = this;
    this.dialog = dialogRef;
    this.registerStringBroadcast();
  }

  registerStringBroadcast() {
    this.changesSubscription = this._broadcaster.on<string>('OnTaskChange')
      .subscribe((task) => {
        this.getTaskProject(true)
      });
    this.changesSubscription = this._broadcaster.on<string>('OnQuoteChange')
      .subscribe((quote) => {
        this.getQuotesProject(true)
      });
    this.changesSubscription = this._broadcaster.on<string>('OnBillingDocChange')
      .subscribe((doc) => {
        this.getInvoicesProject(true)
      });
    this.changesSubscription = this._broadcaster.on<string>('OnCommentAdded')
      .subscribe((comment) => {
        this.getAttachmentsProject(true)
      });
    this.changesSubscription = this._broadcaster.on<string>('OnDeliveryNoteChange')
      .subscribe((note) => {
        this.getDeliveryNotesProject(true)
      });
  }

  setFilters() {
    this.filterTask = {
      filters: {},
      company: this._AuthService.companyId(),
      sort: '',
      skip: 0,
      limit: 5
    };

    this.filterQuotes = {
      company: this._AuthService.companyId(),
      sort: '',
      skip: 0,
      limit: 5
    };

    this.filterInvoices = {
      company: this._AuthService.companyId(),
      filters: {
        isDeleted: undefined,
        status: 'ACTIVE'
      },
      sort: '-createdAt',
      skip: 0,
      limit: 5
    };

    this.filterDeliveryNotes = {
      company: this._AuthService.companyId(),
      filters: {
      },
      sort: '-createdAt',
      skip: 0,
      limit: 5
    };

    //Attachments
    this.filterAttachments = {
      company: this._AuthService.companyId(),
      filters: {
      },
      sort: '-createdAt',
      skip: 0,
      limit: 5
    };
  }

  ngOnInit() {
    this.setFilters();
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.getStatusColors();
    if (!(self.project?.expenses?.length > 0)) this.project.expenses = [getEmptyDetailItemExpense()];
    this.getProject();
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    this.filtered = true;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getProject();
      }
    }, 1000);
  }

  isClient(obj: any): obj is IClient {
    return obj && typeof obj === 'object' && 'firstname' in obj && 'lastname' in obj;
  }

  async getProject() {
    this.loading = true;
    await this._ProjectsHttpService.getProject(this.project._id).subscribe(async (project) => {
      console.log(project);
      this.project = project;
      this.dateFormated = this.formatDateRange(project.startDate, project.endDate)
      await this.getTaskProject();
      await this.getQuotesProject();
      await this.getInvoicesProject();
      await this.getDeliveryNotesProject();
      await this.getAttachmentsProject();
      if (!(self.project?.expenses?.length > 0)) this.project.expenses = [getEmptyDetailItemExpense()];

      this.loading = false;
    });
  }

  //getPresupuestos ???

  //Tasks
  async getTaskProject(reset?: boolean) {
    this.loadingTask = true;
    if (reset) {
      window.scroll(0, 0);
      this.filterTask.skip = 0;
      this.tasks = [];
    }
    this.filterTask.filters = { project: this.project._id }
    await this._ProjectsService.getTasksProject(this.filterTask).subscribe((tasks: any) => {
      this.tasks = _.concat(this.tasks, tasks);
      this.thereAreMoreTask = tasks.length >= self.filterTask.limit;
      this.loadingTask = false;
    })
  }

  loadMoreTask() {
    if (this.thereAreMoreTask && !this.loadingTask) {
      self.filterTask.skip += self.filterTask.limit;
      this.getTaskProject();
    }
  }

  openNewTaskModal(selected: string) {
    (selected === 'SCHEDULED') ? this.openCreateTasksModal({ status: selected, company: this.project.company, client: this.project.client as IClient }, true, false) : this.openCreateTasksModal({ status: 'QUOTED', company: this.project.company, client: this.project.client as IClient }, true, false);
  }

  openCreateTasksModal(task: ITask, scheduling: boolean = false, readOnly: boolean = true) {
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskModalComponent, config);
    self.dialogRef.componentInstance.task = task;
    self.dialogRef.componentInstance.project = this.project._id;
    self.dialogRef.componentInstance.scheduling = scheduling;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTaskProject(true);
    });
  }

  openTasksModal(task: ITask, scheduling: boolean = false, readOnly: boolean = true) {
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskSingleComponent, config);
    self.dialogRef.componentInstance.task = task;
    self.dialogRef.componentInstance.scheduling = scheduling;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      //if (result) this.getProject();
    });
  }

  //Quotes
  async getQuotesProject(reset?: boolean) {
    this.loadingQuotes = true;
    if (reset) {
      window.scroll(0, 0);
      this.filterQuotes.skip = 0;
      this.quotes = [];
    }
    (this.filterQuotes as any).project = this.project._id
    await this._ProjectsService.getQuotesProject(this.filterQuotes).subscribe((quotes: any) => {
      this.quotes = _.concat(this.quotes, quotes);
      this.thereAreMoreQuotes = quotes.length >= self.filterQuotes.limit;
      this.loadingQuotes = false;
    })
  }

  loadMoreQuotes() {
    if (this.thereAreMoreQuotes && !this.loadingQuotes) {
      self.filterQuotes.skip += self.filterQuotes.limit;
      this.getQuotesProject();
    }
  }

  openNewQuotesModal() {
    this.openQuotesModal({ client: this.project.client });
  }

  openQuotesModal(quote: any) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(QuotesModalComponent, config);
    self.dialogRef.componentInstance.quote = quote;
    self.dialogRef.componentInstance.project = this.project._id;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      // if (result) this.getProject();
    });
  }

  //Invoices
  async getInvoicesProject(reset?: boolean) {
    this.loadingInvoices = true;
    if (reset) {
      window.scroll(0, 0);
      this.filterInvoices.skip = 0;
      this.invoices = [];
    }
    this.filterInvoices.project = this.project._id
    await this._ProjectsService.getInvoicesProject(this.filterInvoices).subscribe((invoices: any) => {
      this.invoices = _.concat(this.invoices, invoices);
      this.thereAreMoreInvoices = invoices.length >= self.filterInvoices.limit;
      this.loadingInvoices = false;
    })
  }

  loadMoreInvoices() {
    if (this.thereAreMoreInvoices && !this.loadingInvoices) {
      self.filterInvoices.skip += self.filterInvoices.limit;
      this.getInvoicesProject();
    }
  }

  openNewBDocumentModal(type: IBillingDocumentNames) {
    console.log(this.project)
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(BillingDocumentsModalComponent, config);
    self.pdfDialogRef.componentInstance.document = { type: type, client: this.project.client };
    self.pdfDialogRef.componentInstance.project = this.project._id;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
      //if (result) this.getInvoicesProject(true);
    });
  }

  openEditDocument(document: IBillingDocument) {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(BillingDocumentsModalComponent, config);
    self.dialogRef.componentInstance.document = document;
    self.dialogRef.componentInstance.readOnly = true;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      //if (result) this.getProject();
    });
  }

  //Delivery notes
  async getDeliveryNotesProject(reset?: boolean) {
    this.loadingDeliveryNotes = true;
    if (reset) {
      window.scroll(0, 0);
      this.filterDeliveryNotes.skip = 0;
      this.deliveryNotes = [];
    }
    (this.filterDeliveryNotes as any).project = this.project._id
    //this.filterDeliveryNotes.filters = {project: this.project._id}
    await this._ProjectsService.getDeliveryNotesProject(this.filterDeliveryNotes).subscribe((deliveryNotes: any) => {
      this.deliveryNotes = _.concat(this.deliveryNotes, deliveryNotes);
      this.thereAreMoreDeliveryNotes = deliveryNotes.length >= self.filterDeliveryNotes.limit;
      this.loadingDeliveryNotes = false;
    })
  }

  loadMoreDeliveryNotes() {
    if (this.thereAreMoreDeliveryNotes && !this.loadingDeliveryNotes) {
      this.filterDeliveryNotes.skip += self.filterDeliveryNotes.limit;
      this.getDeliveryNotesProject();
    }
  }

  openDeliveryNote(deliveryNotes: any) {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(DeliveryNotesPDFModalComponent, config);
    self.pdfDialogRef.componentInstance.document = deliveryNotes;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
    });
  }

  //Attachments
  async getAttachmentsProject(reset?: boolean) {
    this.loadingAttachments = true;
    if (reset) {
      window.scroll(0, 0);
      this.filterAttachments.skip = 0;
      this.attachments = [];
    }
    (this.filterAttachments as any).project = this.project._id
    //this.filterAttachments.filters = {project: this.project._id}
    await this._ProjectsService.getAttachmentsProject(this.filterAttachments).subscribe((attachments: any) => {
      console.log(attachments)
      this.attachments = _.concat(this.attachments, attachments);
      this.thereAreMoreAttachments = attachments.length >= self.filterAttachments.limit;
      this.loadingAttachments = false;
    })
  }

  loadMoreAttachments() {
    if (this.thereAreMoreAttachments && !this.loadingAttachments) {
      this.filterAttachments.skip += self.filterAttachments.limit;
      this.getAttachmentsProject();
    }
  }

  openWorkerModal(worker: IWorker) {
    if (!worker._id) return;
    let config = new MatDialogConfig();
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(WorkersModalComponent, config);
    self.dialogRef.componentInstance.worker = worker;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showEdit = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getProject();
    });
  }

  openFile(file: IFile) {
    if (!file._id) return;
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(FileViewModalComponent, config);
    self.dialogRef.componentInstance.file = file;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getProject();
    });
  }

  openTaskModal(task: ITask) {
    if (!task._id) return;
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskSingleComponent, config);
    self.dialogRef.componentInstance.task = task;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showEdit = true;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      //if (result) this.getProject();
    });
  }

  openClientModal(client: IClient) {
    if (!client._id) return;
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ClientsModalComponent, config);
    self.dialogRef.componentInstance.client = client;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showEdit = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getProject();
    });
  }

  //format
  formatDateRange(dateString1: any, dateString2: any) {
    const date1 = new Date(dateString1);
    const date2 = new Date(dateString2);

    const day1 = date1.getDate();
    const month1 = date1.getMonth() + 1;
    const year1 = date1.getFullYear();
    const hours1 = date1.getHours().toString().padStart(2, '0');
    const minutes1 = date1.getMinutes().toString().padStart(2, '0');

    const day2 = date2.getDate();
    const month2 = date2.getMonth() + 1;
    const year2 = date2.getFullYear();
    const hours2 = date2.getHours().toString().padStart(2, '0');
    const minutes2 = date2.getMinutes().toString().padStart(2, '0');

    if (day1 === day2 && month1 === month2 && year1 === year2) {
      return `${day1}/${month1}/${year1} ${hours1}:${minutes1} - ${hours2}:${minutes2}`;
    } else {
      return `${day1}/${month1}/${year1} - ${day2}/${month2}/${year2}`;
    }
  }

  openProjectsModal(project: any) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '900px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ProjectsModalComponent, config);
    self.dialogRef.componentInstance.project = project;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getProject();
    });
  }

  async getStatusColors() {
    this.taskStatusColors = { DEFAULT: 'white', SCHEDULED: '#337AB7', INVOICED: '#FF9E00' };
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_OPEN_COLOR)
      .then((color) => { this.taskStatusColors.OPEN = color; this.taskStatusColors.QUOTED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_ONGOING_COLOR)
      .then((color) => { this.taskStatusColors.ONGOING = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_COMPLETED_COLOR)
      .then((color) => { this.taskStatusColors.COMPLETED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_CANCELLED_COLOR)
      .then((color) => { this.taskStatusColors.CANCELLED = color });

    this.quoteStatusColors = { DEFAULT: 'white', SCHEDULED: '#337AB7', INVOICED: '#337AB7' };
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_OPEN_COLOR)
      .then((color) => { this.quoteStatusColors.QUOTED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_CANCELLED_COLOR)
      .then((color) => { this.quoteStatusColors.CANCELLED = color });
  }
}